export default {
  baseURL: import.meta.env.VITE_API_BASE_URL,
  customerDomain: import.meta.env.VITE_CUSTOMER_DOMAIN,
  paymentGateAPS: import.meta.env.VITE_PAYMENT_GATEWAY,
  merchantIdAPS: import.meta.env.VITE_APS_MERCHANT_ID,
  merchantAccessCodeAPS: import.meta.env.VITE_APS_MERCHANT_ACCESS_CODE,
  passSHAPass: import.meta.env.VITE_APS_SHA_PASS,
  prod: import.meta.env.PROD,
  socketURL: import.meta.env.VITE_WEBSOCKET_URL,
  sentryDsn: import.meta.env.VITE_SENTRY_FRONTEND_DSN,
};

// TEMPORARY: Feature flag to disable cookie consent banner and auto-grant consent
// Set to true to disable banner and auto-grant consent
// Set to false to restore normal cookie consent behavior
export const AUTO_GRANT_CONSENT = true; // ← Change this to false to rollback

type FooterEntry = {
  key: string;
  link: string;
};

type Footer = {
  explore: FooterEntry[];
  company: FooterEntry[];
  legal: FooterEntry[];
};

export const footerConfig: Footer = {
  explore: [
    {
      key: "footer.programs",
      link: "/programs",
    },
    {
      key: "footer.challenges",
      link: "/community-challenge?tab=",
    },
    {
      key: "footer.sadaqah_jariyah",
      link: "/community-challenge?tab=Sadaqah Jariya",
    },
    {
      key: "footer.fatawa",
      link: "/fatawa",
    },
  ],
  company: [
    {
      key: "footer.about",
      link: "/about-us",
    },
    {
      key: "footer.faq",
      link: "/faqs",
    },
    {
      key: "footer.contact",
      link: "/contact",
    },
    {
      key: "footer.join_us",
      link: "/join-us",
    },
    {
      key: "footer.blogs",
      link: "/blogs",
    },
  ],
  legal: [
    {
      key: "footer.terms",
      link: "/policy?type=terms",
    },
    {
      key: "footer.privacy",
      link: "/policy?type=privacy",
    },
    {
      key: "footer.cookies",
      link: "/policy?type=cookies",
    },
  ],
};

// Supported languages
export const SUPPORTED_LANGUAGES = ["en", "ar"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const DEFAULT_LANGUAGE: SupportedLanguage = "ar";
